import { Injectable } from "@angular/core"

import { NavController } from "@ionic/angular"
import { HttpService } from "../_provider/http.service"
import { JwtHelperService } from '@auth0/angular-jwt';

const helper = new JwtHelperService()

@Injectable({
  providedIn: 'root'
})
export class AuthGuardCustomerService  {

  constructor(private http: HttpService, private navCtrl: NavController) { }

  canActivate(): boolean{

    let decoded = helper.decodeToken(this.http.token)
    if(this.http.token != "" && decoded.role == "customer") return true
    else {
      this.navCtrl.navigateRoot("/login")
      return false
    }
  }
}
